export const UPDATE_CAROUSEL = 'UPDATE_CAROUSEL'
